export default {}



// WEBPACK FOOTER //
// ./src/page/int/face/driverFaceRecord/lang/index.en.js